import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker, Location } from 'react-router';
import UIKitModal from '../../shared/UIKITComponents/Modal';
import UIKitButton from '../../shared/UIKITComponents/Button';

interface Props {
  when: boolean;
  shouldBlockNavigation: () => boolean;
  onSave?: (locationPath: Location | null) => void;
  from?: Location;
  message?: string;
}

const RouteLeavingGuardGrv: React.FC<Props> = (props: Props) => {
  const { when, shouldBlockNavigation, onSave, from, message } = props;
  const { t } = useTranslation();

  const blocker = useBlocker(
    ({ nextLocation }) =>
      when && shouldBlockNavigation() && (!from || from.pathname !== nextLocation.pathname)
  );

  useEffect(
    () => () => {
      // patch: scroll remain locked when redirect
      const body = document.querySelector('body');
      if (!body) {
        return;
      }
      body.classList.remove('modal-open');
    },
    [blocker.state]
  );

  const modalVisible = blocker.state === 'blocked';

  const handleCancelClick = () => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  };

  const handleConfirmNavigationClick = () => {
    if (blocker.state === 'blocked') {
      blocker.proceed();
    }
  };

  return (
    <UIKitModal
      title={t('discardChanges')}
      size="sm"
      open={modalVisible}
      onClose={handleCancelClick}
      actions={
        <>
          <UIKitButton
            text={t('cancel')}
            variant="link"
            onClick={handleCancelClick}
            color="secondary"
          />
          <UIKitButton
            text={!onSave ? t('discardChanges') : t('dontSave')}
            variant="flat"
            color="primary"
            onClick={() => {
              handleConfirmNavigationClick();
            }}
          />

          {onSave && (
            <UIKitButton
              text={t('saveChanges')}
              variant="flat"
              color="primary"
              onClick={() => onSave(blocker.state === 'blocked' ? blocker.location : null)}
            />
          )}
        </>
      }
      // title={t('saveChanges')}
    >
      {message || t('dirtyPopupMsg')}
    </UIKitModal>
  );
};

export default RouteLeavingGuardGrv;
